module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 5.f1524c5a.png";